<template>
  <div>
    <el-tiptap
      v-model="object[fieldName]"
      :extensions="extensions"
      @onBlur="onInputChange"
      @onUpdate="onInputUpdate"
    />
  </div>
</template>

<script>
import {
  Doc,
  Link,
  Text,
  Paragraph,
  Heading,
  Bold,
  Underline,
  Italic,
  Strike,
  ListItem,
  BulletList,
  OrderedList,
  CodeView,
} from "element-tiptap";
import codemirror from "codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/xml/xml.js";
import "codemirror/addon/selection/active-line.js";
import "codemirror/addon/edit/closetag.js";
export default {
  data() {
    return {
      textUpdated: false,
      extensions: [
        new Doc(),
        new Text(),
        new Paragraph(),
        new Heading({ level: 4 }),
        new Bold({ bubble: true }),
        new Underline({ bubble: true, menubar: true }),
        new Italic(),
        new Strike(),
        new ListItem(),
        new BulletList(),
        new OrderedList(),
        new Link(),
        new CodeView({
          codemirror,
          codemirrorOptions: {
            styleActiveLine: true,
            autoCloseTags: true,
          },
        }),
      ],
    };
  },
  props: {
    fieldName: {
      type: String,
      required: true,
    },
    object: {
      type: Object,
      required: false,
    },
  },
  methods: {
    onInputUpdate() {
      this.textUpdated = true;
    },
    onInputChange() {
      if (this.textUpdated == true) {
        this.$emit("onInputChange");
      }
    },
  },
};
</script>
